<template>
  <div class="dynamic">
    <div class="w">
      <!-- 边框 -->

      <div class="left_list">
        <div class="inner_blocks">
			<div class="xuebox">
				首页 > 科汇云动态 > <span>{{ xq.title }}</span>
			</div>
			<div class="taiyxy">
				科汇云动态
			</div>
          <div class="art_topics">
            <span class="ar_right"
              ><div class="top_title">
                {{ xq.title }}
              </div>
              <div class="ar_details">
                <span class="check_list">发布时间：{{
                  xq.create_time
                }}</span>
              </div></span
            >
          </div>
          <div class="wrap_content">
            <div class="rich_media_content" id="js_content">
              
              <!-- 文字 -->
              <section
                data-tools="135编辑器"
                data-id="102962"
                style="
                  max-width: 100%;
                  font-family: -apple-system, BlinkMacSystemFont,
                    'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB',
                    'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;
                  letter-spacing: 0.544px;
                  white-space: normal;
                  background-color: rgb(255, 255, 255);
                  box-sizing: border-box !important;
                  word-wrap: break-word !important;
                "
              >
                <section
                  style="
                    margin: 10px auto;
                    max-width: 100%;
                    text-align: center;
                    box-sizing: border-box !important;
                    word-wrap: break-word !important;
                  "
                >
                  <section
                    style="
                      margin-top: -10px;
                      max-width: 100%;
                      box-sizing: border-box;
                      word-wrap: break-word !important;
                    "
                  >
                    <section
                      style="
                        max-width: 100%;
                        background-image: url('https://doctor-filemanager.oss-cn-beijing.aliyuncs.com/mp/202104/20210424084542248936.png');
                        background-position: 0% 0%;
                        background-size: 100%;
                        background-repeat: repeat;
                        background-attachment: initial;
                        background-origin: initial;
                        background-clip: initial;
                        transform: rotate(0deg);
                        box-sizing: border-box !important;
                        word-wrap: break-word !important;
                      "
                    >
                      <section
                        style="
                          max-width: 100%;
                          box-sizing: border-box;
                          word-wrap: break-word !important;
                        "
                      >
                        <section
                          data-autoskip="1"
                          style="
                            max-width: 100%;
                            text-align: justify;
                            line-height: 1.75em;
                            letter-spacing: 1.5px;
                            font-size: 14px;
                            color: rgb(11, 102, 217);
                            background: transparent;
                            box-sizing: border-box !important;
                            word-wrap: break-word !important;
                          "
                        >
                        <!-- 图片 -->
              <!-- <p style="margin-top: 0.53rem">
                <img
                  data-ratio="0.667"
                  :src="xq.image"
                  data-type="jpeg"
                  data-w="1000"
                  class="img"
                  style="
                    vertical-align: top;
                    border-width: 0px;
                    border-style: initial;
                    border-color: initial;
                    -webkit-user-drag: none;

                    margin-right: auto;
                    margin-left: auto;
                    display: block;
                  "
                />
              </p> -->
                          <p
                            style="
                              max-width: 100%;
                              min-height: 1em;
                              line-height: 2em;
                              box-sizing: border-box !important;
                              word-wrap: break-word !important;
                            "
                          >
                            <span
                              style="
                                max-width: 100%;
                                color: rgb(62, 62, 62);
                                font-size: 14px;
                                box-sizing: border-box !important;
                                word-wrap: break-word !important;
                              "
                              v-html="xq.content"
                            >
                            </span>
                          </p>
                        </section>
                      </section>
                    </section>
                  </section>
                </section>
              </section>
              

              <!-- 文字 -->
              <!-- <section
                data-id="103243"
                data-tools="135编辑器"
                style="
                  max-width: 100%;
                  font-family: -apple-system, BlinkMacSystemFont,
                    'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB',
                    'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;
                  letter-spacing: 0.544px;
                  white-space: normal;
                  background-color: rgb(255, 255, 255);
                  box-sizing: border-box !important;
                  word-wrap: break-word !important;
                "
              >
                <section
                  hm_fix="396:657"
                  style="
                    margin: 10px auto;
                    max-width: 100%;
                    box-sizing: border-box !important;
                    word-wrap: break-word !important;
                  "
                >
                  <section
                    style="
                      max-width: 100%;
                      display: inline-block;
                      box-sizing: border-box !important;
                      word-wrap: break-word !important;
                    "
                  >
                     <section
                      data-brushtype="text"
                      style="
                        padding: 8px 12px;
                        max-width: 100%;
                        box-sizing: border-box;
                        border-radius: 4px;
                        background-color: rgb(54, 96, 146);
                        font-size: 16px;
                        letter-spacing: 1.5px;
                        color: rgb(255, 255, 255);
                        word-wrap: break-word !important;
                      "
                    >
                      <strong
                        style="
                          max-width: 100%;
                          box-sizing: border-box !important;
                          word-wrap: break-word !important;
                        "
                        >TIP</strong
                      >
                    </section> 
                    <section
                      style="
                        margin-left: 17px;
                        max-width: 100%;
                        box-sizing: border-box;
                        width: 0px;
                        height: 1px;
                        border-top: 8px solid rgb(54, 96, 146);
                        border-left: 8px solid transparent;
                        overflow: hidden;
                        word-wrap: break-word !important;
                      "
                    >
                      <br
                        style="
                          max-width: 100%;
                          box-sizing: border-box !important;
                          word-wrap: break-word !important;
                        "
                      />
                    </section> 
                  </section>
                  <section
                    data-brushtype="text"
                    style="
                      margin-top: 5px;
                      padding: 10px 20px;
                      max-width: 100%;
                      box-sizing: border-box;
                      border-width: 0.5px;
                      border-style: solid;
                      border-color: rgb(54, 96, 146);
                      border-radius: 8px;
                      background-color: rgb(242, 249, 255);
                      line-height: 1.75em;
                      letter-spacing: 1.5px;
                      font-size: 16px;
                      color: rgb(0, 97, 182);
                      word-wrap: break-word !important;
                    "
                  >
                    <span
                      style="
                        max-width: 100%;
                        font-size: 14px;
                        color: rgb(23, 54, 93);
                        box-sizing: border-box !important;
                        word-wrap: break-word !important;
                      "
                      >文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案</span
                    >
                  </section>
                  <p><br /></p>
                </section>
              </section> -->

              <!-- 图片 -->
              <!-- <p
                style="
                  margin-top: 0.53rem;
                  text-size-adjust: none;
                  user-select: text;
                  -webkit-tap-highlight-color: transparent;
                  color: rgba(0, 0, 0, 0.953);
                  font-family: MyFont;
                  white-space: normal;
                  background-color: rgb(255, 255, 255);
                  text-indent: 2em;
                  font-size: 0.48rem !important;
                "
              >
                <img
                  data-ratio="0.667"
                  src="../../../assets/img/kefuyun/js1.png"
                  data-type="jpeg"
                  data-w="1000"
                  style="
                    vertical-align: top;
                    border-width: 0px;
                    border-style: initial;
                    border-color: initial;
                    -webkit-user-drag: none;
                    width: 702px;
                    height: 468.229px;
                    margin-right: auto;
                    margin-left: auto;
                    display: block;
                  "
                />
              </p> -->

              <!-- 文字 -->
              <!-- <section
                data-role="paragraph"
                style="
                  max-width: 100%;
                  font-family: -apple-system, BlinkMacSystemFont,
                    'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB',
                    'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;
                  letter-spacing: 0.544px;
                  white-space: normal;
                  background-color: rgb(255, 255, 255);
                  box-sizing: border-box !important;
                  word-wrap: break-word !important;
                "
              >
                <section
                  data-id="us-3881602"
                  data-type="lspecial04,lspecial02"
                  data-md5="79833"
                  data-tools="135编辑器"
                  style="
                    margin-top: 1px;
                    margin-bottom: 1px;
                    padding: 4px;
                    max-width: 100%;
                    letter-spacing: 0.544px;
                    text-size-adjust: auto;
                    outline: rgba(94, 102, 117, 0) dashed 1px;
                    min-height: 30px;
                    box-sizing: border-box !important;
                    word-wrap: break-word !important;
                    overflow-wrap: break-word !important;
                  "
                >
                  <section
                    data-md5="79833"
                    style="
                      max-width: 100%;
                      box-sizing: border-box;
                      border-width: 1px;
                      border-style: dashed;
                      border-color: rgb(54, 96, 146);
                      word-wrap: break-word !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <section
                      data-md5="79833"
                      style="
                        padding: 15px;
                        max-width: 100%;
                        box-sizing: border-box;
                        word-wrap: break-word !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <section
                        data-md5="79833"
                        style="
                          max-width: 100%;
                          box-sizing: border-box !important;
                          word-wrap: break-word !important;
                          overflow-wrap: break-word !important;
                        "
                      >
                        <section
                          style="
                            max-width: 100%;
                            line-height: 2em;
                            box-sizing: border-box !important;
                            word-wrap: break-word !important;
                          "
                        >
                          <p
                            style="
                              max-width: 100%;
                              min-height: 1em;
                              line-height: 1.75em;
                              box-sizing: border-box !important;
                              word-wrap: break-word !important;
                            "
                          >
                            <span
                              style="
                                font-family: 微软雅黑, Arial, sans-serif;
                                max-width: 100%;
                                letter-spacing: 1px;
                                color: rgb(62, 62, 62);
                                font-size: 14px;
                                box-sizing: border-box !important;
                                word-wrap: break-word !important;
                              "
                              >文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案文案</span
                            >
                          </p>
                        </section>
                      </section>
                    </section>
                  </section>
                </section>
                <section
                  data-role="paragraph"
                  style="
                    max-width: 100%;
                    box-sizing: border-box !important;
                    word-wrap: break-word !important;
                  "
                >
                  <p
                    style="
                      max-width: 100%;
                      min-height: 1em;
                      box-sizing: border-box !important;
                      word-wrap: break-word !important;
                    "
                  >
                    <br
                      style="
                        max-width: 100%;
                        box-sizing: border-box !important;
                        word-wrap: break-word !important;
                      "
                    />
                  </p>
                </section>
              </section> -->

              <!-- 星星 -->
              <!-- <section
                data-role="paragraph"
                style="
                  max-width: 100%;
                  font-family: -apple-system, BlinkMacSystemFont,
                    'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB',
                    'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;
                  letter-spacing: 0.544px;
                  white-space: normal;
                  background-color: rgb(255, 255, 255);
                  box-sizing: border-box !important;
                  word-wrap: break-word !important;
                "
              >
                <p
                  style="
                    max-width: 100%;
                    min-height: 1em;
                    text-align: center;
                    box-sizing: border-box !important;
                    word-wrap: break-word !important;
                  "
                >
                  <img
                    data-type="gif"
                    class="__bg_gif"
                    data-ratio="0.9629629629629629"
                    data-w="162"
                    src="https://doctor-filemanager.oss-cn-beijing.aliyuncs.com/mp/202104/20210424084537958176.gif"
                    style="
                      box-sizing: border-box;
                      letter-spacing: 0.544px;
                      text-align: justify;
                      font-family: -apple-system, BlinkMacSystemFont, Arial,
                        sans-serif;
                      word-wrap: break-word !important;
                      overflow-wrap: break-word !important;
                      visibility: visible !important;
                      width: 50px !important;
                    "
                  />
                </p>
              </section> -->

              <!-- 结束 -->
              <!-- <section
                data-tools="135编辑器"
                data-id="101056"
                style="
                  max-width: 100%;
                  font-family: -apple-system, BlinkMacSystemFont,
                    'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB',
                    'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;
                  letter-spacing: 0.544px;
                  white-space: normal;
                  background-color: rgb(255, 255, 255);
                  color: rgb(0, 0, 0);
                  font-size: medium;
                  text-align: start;
                  box-sizing: border-box !important;
                  word-wrap: break-word !important;
                  overflow-wrap: break-word !important;
                "
              >
                <section
                  style="
                    margin: 10px auto;
                    max-width: 100%;
                    text-align: center;
                    box-sizing: border-box !important;
                    word-wrap: break-word !important;
                    overflow-wrap: break-word !important;
                  "
                >
                  <section
                    style="
                      max-width: 100%;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      box-sizing: border-box !important;
                      word-wrap: break-word !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <section
                      style="
                        max-width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        box-sizing: border-box !important;
                        word-wrap: break-word !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <section
                        style="
                          margin-right: -4px;
                          max-width: 100%;
                          box-sizing: border-box;
                          width: 15px;
                          word-wrap: break-word !important;
                          overflow-wrap: break-word !important;
                        "
                      >
                        <img
                          data-ratio="0.8461538461538461"
                          data-type="png"
                          data-w="13"
                          data-width="100%"
                          src="https://doctor-filemanager.oss-cn-beijing.aliyuncs.com/mp/202104/20210424084541105736.png"
                          style="
                            box-sizing: border-box;
                            display: block;
                            word-wrap: break-word !important;
                            overflow-wrap: break-word !important;
                            visibility: visible !important;
                            width: 15px !important;
                          "
                        />
                      </section>
                      <section
                        style="
                          max-width: 100%;
                          box-sizing: border-box;
                          width: 20px;
                          height: 1px;
                          background: rgb(240, 14, 32);
                          overflow: hidden;
                          word-wrap: break-word !important;
                          overflow-wrap: break-word !important;
                        "
                      >
                        <br
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            word-wrap: break-word !important;
                            overflow-wrap: break-word !important;
                          "
                        />
                      </section>
                    </section>
                    <section
                      data-brushtype="text"
                      style="
                        padding: 4px 10px;
                        max-width: 100%;
                        box-sizing: border-box;
                        font-size: 14px;
                        letter-spacing: 1.5px;
                        color: rgb(240, 14, 32);
                        word-wrap: break-word !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span style="font-size: 14px">END</span>
                    </section>
                    <section
                      hm_fix="340:557"
                      style="
                        max-width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        box-sizing: border-box !important;
                        word-wrap: break-word !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <section
                        style="
                          max-width: 100%;
                          box-sizing: border-box;
                          width: 20px;
                          height: 1px;
                          background: rgb(240, 14, 32);
                          overflow: hidden;
                          word-wrap: break-word !important;
                          overflow-wrap: break-word !important;
                        "
                      >
                        <br
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            word-wrap: break-word !important;
                            overflow-wrap: break-word !important;
                          "
                        />
                      </section>
                      <section
                        style="
                          margin-left: -4px;
                          max-width: 100%;
                          box-sizing: border-box;
                          width: 15px;
                          word-wrap: break-word !important;
                          overflow-wrap: break-word !important;
                        "
                      >
                        <img
                          data-ratio="0.8461538461538461"
                          data-type="png"
                          data-w="13"
                          data-width="100%"
                          src="https://doctor-filemanager.oss-cn-beijing.aliyuncs.com/mp/202104/20210424084541105736.png"
                          style="
                            box-sizing: border-box;
                            display: block;
                            word-wrap: break-word !important;
                            overflow-wrap: break-word !important;
                            visibility: visible !important;
                            width: 15px !important;
                          "
                        />
                      </section>
                    </section>
                  </section>
                </section>
              </section> -->
            </div>
          </div>
        </div>
		<div class="righta">
			<div class="tuititle">
				推荐动态
			</div>
			<div class="neup">
				<div class="uptxt">
					上一篇
				</div>
				<div class="pitxt">
					经济数据半年报：投身绿色产业蓝海 低碳如何发展高质量
				</div>
				<div class="see">查看详情></div>
				
				<div class="uptxt">
					下一篇
				</div>
				<div class="pitxt">
					四川省多点激发区域科技创新效能促进川渝科技协同创新
				</div>
				<div class="see">查看详情></div>
			</div>
			
			<div class="back">>返回列表</div>
		</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ArticleXq } from "../../../common/js/api";
import { formatDate } from "../../../common/js/times"; //时间
import { urlImg } from "@/common/js/url";
export default {
  name: "DynamicNei",
  data() {
    return {
      ID: "",
      xq: {},
    };
  },
  filters: {
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
  },
  created() {
    this.urlImg = urlImg();
    this.ID = this.$route.query.id;
    this.ArticleXq();
  },
  methods: {
    //   政策详情
    ArticleXq(id) {
      ArticleXq({
        id: this.ID,
      })
        .then((res) => {
          console.log(res);
          this.xq = res.data;
          // this.xq.level = this.xq.leveltype.name;
        })
        .catch(() => {});
    },
  },

  mounted() {},
};
</script>

<style scoped lang="less">
	.w{
		width: 1400px;
	}
.dynamic{
	margin-top: 136px;
}
.left_list {
  margin-top: 30px;
  padding: 12px 0 20px;
  display: flex;
  justify-content: space-between;
}
.inner_blocks{
	width: 1060px;
	padding-right: 40px;
	border-right: 1px solid #eeeeee;
}
.art_topics .ar_right .top_title {
  color: #4d4d4d;
  font-weight: 700;
  font-size: 28px;
  line-height: 1.2;
  
}
.art_topics .ar_right .ar_details {
  margin: 16px 0;
  color: rgba(105, 105, 105, 100);
  font-size: 14px;
  color: #999999;
}
.img {
  // // width: 609px;
  // height: 228px;
  height: auto;
  // width: auto;
}
.xuebox{
	font-size: 12px;
	color: #8a9095;
	padding-bottom: 70px;
	padding-top: 15px;
	span{
		font-size: 12px;
		color: #0289f4;
	}
}
.taiyxy{
	font-size: 16px;
	color: #c8c8c8;
	padding-bottom: 20px;
}
.ar_details{
	border-bottom: 1px solid #eeeeee;
	padding-bottom: 15px;
}
.righta{
	width: 300px;
	padding-top: 115px;
}
.tuititle{
	font-size: 24px;
	color: #222222;
	font-weight: bold;
	padding-bottom: 25px;
	border-bottom: 1px solid #eeeeee;
}
.neup{
	border-bottom: 1px solid #eeeeee;
	padding-bottom: 13px;
}
.uptxt{
	font-size: 15px;
	color: #222222;
	padding: 30px 0 12px;
}
.pitxt{
	font-size: 15px;
	color: #666666;
	line-height: 22px;
	padding-bottom: 20px;
}
.see{
	font-size: 15px;
	color: #0289f4;
	padding-bottom: 30px;
	cursor: pointer;
}
.back{
	width: 140px;
	height: 40px;
	background-color: #0289f4;
	border-radius: 30px;
	text-align: center;
	line-height: 40px;
	color: #ffffff;
	font-size: 16px;
	cursor: pointer;
	margin-top: 50px;
}
@media screen and (max-width: 1200px) {
	.dynamic{
		margin-top: 15rem;
	}
	.w{
		width: 98%;
	}
	.art_topics .ar_right .top_title{
		font-size: 2.4rem;
		padding-top: 1.5rem;
	}
	.left_list{
		padding: 1.5rem;
	}
	.art_topics .ar_right .ar_details{
		font-size: 1.6rem;
		padding: 0 0 1rem 0;
	}
	span{
		font-size: 1.6rem !important;
		line-height: 3rem !important;
	}
	.xuebox{
		font-size: 1.6rem !important;
		line-height: 3rem !important;
	}
	.righta{
		display: none;
	}
	.inner_blocks{
		width: 100%;
		border: none;
		padding: 0;
	}
}
</style>